export default "__VITE_ASSET__DAhNA3JG__"